import { useTranslations } from "next-intl";
import { useState, memo, useCallback, useEffect } from "react";
import ahoy from "@lib/ahoy";
import { analytics } from "@lib/trackers/analytics";
import { useFilterRecentlyModified } from "@hooks/use-catalog";
import Button from "@components/core/Button";
import Input from "@components/core/Input";

const mainIndex = process.env.NEXT_PUBLIC_ALGOLIA_MAIN_INDEX_V2;

const AvailabilitiesSection = memo(function AvailabilitiesSection({
  setUiState,
  sizeItems,
  isFilterAvailableChecked,
}) {
  const t = useTranslations("catalog");

  const filterRecentlyModified = useFilterRecentlyModified();

  const [availabilitiesInfoOpen, setAvailabilitiesInfoOpen] = useState(false);
  const [switchIsChecked, setSwitchIsChecked] = useState(isFilterAvailableChecked);

  const switchInStock = useCallback(() => {
    const eventData = {
      button: "filter",
      filter: "availabilities",
      value: isFilterAvailableChecked ? "all" : "in_stock",
    };
    ahoy("$click", eventData);
    analytics.track("$click", eventData);

    filterRecentlyModified("availabilities");

    const newIsChecked = !isFilterAvailableChecked;

    setSwitchIsChecked(newIsChecked);

    const selectedSizes = sizeItems.filter((item) => item.isRefined).map((item) => item.value);

    setTimeout(() => {
      if (newIsChecked) {
        setUiState((prev) => ({
          ...prev,
          [mainIndex]: {
            ...prev[mainIndex],
            refinementList: {
              ...prev[mainIndex].refinementList,
              in_stock: ["true"],
              sizes: [],
              available_sizes: selectedSizes,
            },
          },
        }));
      } else {
        setUiState((prev) => ({
          ...prev,
          [mainIndex]: {
            ...prev[mainIndex],
            refinementList: {
              ...prev[mainIndex].refinementList,
              in_stock: ["false", "true"],
              sizes: selectedSizes,
              available_sizes: [],
            },
          },
        }));
      }
    }, 200);
  }, [filterRecentlyModified, isFilterAvailableChecked, setUiState, sizeItems]);

  useEffect(() => {
    setSwitchIsChecked(isFilterAvailableChecked);
  }, [isFilterAvailableChecked]);

  return (
    <div
      className="p-3 border-bottom d-flex justify-content-between"
      key="availabilities"
    >
      <div>
        <div className="d-flex align-items-center">
          <span>{t("filters.section_titles.availabilities")}</span>
          <Button
            variant="link-primary"
            leftIconName="circle-info"
            onClick={() => setAvailabilitiesInfoOpen(true)}
            size="sm"
          />
        </div>
        {availabilitiesInfoOpen && (
          <div className="font-size-xs text-gray mt-2">{t("filters.availabilities.info")}</div>
        )}
      </div>
      <Input
        type="switch"
        checked={switchIsChecked}
        onChange={switchInStock}
      />
    </div>
  );
});

export default AvailabilitiesSection;
